import { all, fork, put, select, takeLatest } from 'redux-saga/effects';
import {
  getShopsAPI,
  ACTION_GET_PRODUCTS,
  ACTION_GET_PRODUCT_DETAIL,
  getProductDetailAPI,
} from './index';

function* loadMerchandisePage() {
  // Always fetch shops first when entering the page
  // This ensures we have fresh data
  // After shops are loaded, handleGetShopsSuccess will automatically fetch products
  yield put(getShopsAPI());
}

function* loadProductDetailPage() {
  // Get shopId and productId from location payload
  const { location } = yield select();
  const shopId = location?.payload?.shopId;
  const productId = location?.payload?.productId;
  
  if (shopId && productId) {
    yield put({ type: ACTION_GET_PRODUCT_DETAIL, payload: { shopId, productId } });
    yield put(getProductDetailAPI(shopId, productId));
  }
}

function* handleGetProducts() {
  // Products are already loaded in the reducer
  // This saga can be extended for additional logic if needed
}

function* handleGetProductDetail(action) {
  const { shopId, productId } = action.payload;
  if (shopId && productId) {
    yield put(getProductDetailAPI(shopId, productId));
  }
}

export default function* merchandiseSaga() {
  yield all([
    fork(takeLatest, ACTION_GET_PRODUCTS, handleGetProducts),
    fork(takeLatest, ACTION_GET_PRODUCT_DETAIL, handleGetProductDetail),
  ]);
}

export { loadMerchandisePage, loadProductDetailPage };
